import React from 'react';
import { PropTypes } from 'prop-types';
import { useFelaEnhanced } from '@ackee/fela';
import { FormattedMessage } from 'react-intl';

import { useLocation } from '@reach/router';

import { AnalyticsEvent, getPlausibleClassName } from 'utils/analytics';

import * as UI from '../../../ui';
import Config from '../../../../config';
import { LANG_ENV } from '../../../../config/env';

import * as felaRules from './InquirySectionWithImage.styles';

import Image from '../Image';

const { DynamicContainer, ContainerType, Title, TitleTypes, LocalizedLink } = UI;

const InquirySectionWithImage = ({ reference = null }) => {
    const { styles, rules } = useFelaEnhanced(felaRules);
    const { pathname } = useLocation();

    return (
        <DynamicContainer
            ref={reference}
            extend={{ container: rules.extendContainer }}
            isFluid
            as={ContainerType.SECTION}
            type={ContainerType.GRID}
        >
            <DynamicContainer columns={7} extend={{ container: rules.textContainer }}>
                <Title as={TitleTypes.H3} type={TitleTypes.H3} extend={{ title: rules.extendTitle }}>
                    <FormattedMessage id="inquiry.section.title" />
                </Title>
                <LocalizedLink
                    eventId="contact-bottom"
                    className={getPlausibleClassName(styles.link, AnalyticsEvent.CONTACT_BOTTOM_CLICK, {
                        origin_path: pathname,
                    })}
                    to={Config.routes['/contact']}
                >
                    <Title size={TitleTypes.H3_LINK} as={TitleTypes.H5} extend={rules.extendLinkTitle}>
                        <FormattedMessage id="inquiry.section.cta" />
                    </Title>
                </LocalizedLink>
            </DynamicContainer>
            <DynamicContainer extend={{ container: rules.imageContainer }} columns={5}>
                <Image alt={'inquiry.section.cta'} src={`inquiry/img_contact_us_${LANG_ENV}.jpeg`} />
            </DynamicContainer>
        </DynamicContainer>
    );
};

InquirySectionWithImage.propTypes = {
    reference: PropTypes.shape(),
};

export default InquirySectionWithImage;
